<template>
  <div class="position-relative">
    <slot></slot>
    <i
      v-if="active"
      class="fas fa-lg fa-check-circle"
      style="position: absolute; top: 0; right: 0; color: var(--primary); background-color: white; border-radius: 50%;"
    />
  </div>
</template>

<script>
export default {
  props: {
    active: {
      type: Boolean,
      default: false
    }
  }
};
</script>
